// extracted by mini-css-extract-plugin
export default {"HotspotMini":"HotspotMini-module__HotspotMini___Ivz5c"};